import { useTranslation } from 'react-i18next';
import { useSubscription } from 'services/hooks';
import { StyledContainer, StyledStack, StyledTypography } from './styled';
import UpgradeContainer from './components/UpgradeContainer';
import WhitelistComponent from './components/WhitelistComponent';

const YoutubeChannel = () => {
  const { t } = useTranslation();
  const { isFreeAccount } = useSubscription();

  return (
    <StyledContainer>
      <StyledTypography data-testid="youtube-channel-header" variant="h1">
        {t('account:youtubeChannel:title')}
      </StyledTypography>
      <StyledStack>
        {isFreeAccount && <UpgradeContainer />}
        <WhitelistComponent />
      </StyledStack>
    </StyledContainer>
  );
};

export default YoutubeChannel;
